import { storeOverviewColumns, stackStoreOverviewColumns } from "./storeOverviewPresentation";

export type ExecutiveOverviewColumn = { key: string; label: string; width: number; group: number };
export type ExistingExecutiveColumn = { key: string; label: string };

// Existing fields stay intact. The approved remaining/day screen column is
// opt-in only for views supplying their existing raw target and sales values.
export function executiveOverviewColumns(available: ExistingExecutiveColumn[], language: string, includeRemaining = false): ExecutiveOverviewColumn[] {
  if (includeRemaining && available.some(column => column.key === "target")) available = [...available, { key: "remaining", label: "" }];
  const approved = storeOverviewColumns(language, true);
  const byKey = new Map(approved.map(column => [column.key, column]));
  const originals = new Map(available.map(column => [column.key, column]));
  const order = ["label", "weekday", ...approved.map(column => column.key).filter(key => key !== "label")];
  const keys = [...order.filter(key => originals.has(key)), ...available.map(column => column.key).filter(key => !order.includes(key))];
  return keys.map(key => {
    const original = originals.get(key)!;
    if (key === "label") return { ...original, width: originals.has("weekday") ? 110 : 200, group: 0 };
    if (key === "weekday") return { ...original, width: 110, group: 0 };
    const specification = byKey.get(key);
    return specification ? { ...specification } : { ...original, width: 120, group: 3 };
  });
}

export function executiveOverviewLayout(available: ExistingExecutiveColumn[], language: string, hidden: Set<string>, includeRemaining = false) {
  return stackStoreOverviewColumns(executiveOverviewColumns(available, language, includeRemaining).filter(column => !hidden.has(column.key)));
}
